import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M15.313.5A4.688 4.688 0 0 1 20 5.188v10.625a4.688 4.688 0 0 1-4.688 4.687H4.688A4.688 4.688 0 0 1 0 15.812V5.188A4.688 4.688 0 0 1 4.688.5h10.625Zm-11.8 7.63a.314.314 0 0 0-.313.312v8.752a.312.312 0 0 0 .313.313h2.289a.314.314 0 0 0 .312-.313V8.442a.313.313 0 0 0-.312-.312h-2.29Zm10.023-.234a3.067 3.067 0 0 0-2.75 1.502.025.025 0 0 1-.013.011.025.025 0 0 1-.015.001.027.027 0 0 1-.014-.009.026.026 0 0 1-.005-.015v-.944a.313.313 0 0 0-.312-.312h-2.17a.314.314 0 0 0-.313.312v8.751c0 .083.033.163.091.222.059.059.139.09.222.09h2.286a.312.312 0 0 0 .313-.312v-4.325c0-1.223.232-2.408 1.748-2.408 1.495 0 1.514 1.4 1.514 2.487v4.247a.312.312 0 0 0 .313.313h2.287a.312.312 0 0 0 .312-.313l.001-4.83c0-2.526-.544-4.468-3.495-4.468ZM4.658 3.47c-.927 0-1.69.763-1.69 1.69 0 .926.764 1.689 1.691 1.689s1.689-.763 1.689-1.69c0-.927-.763-1.69-1.69-1.69Z"
    }, null, -1)
  ]))]))
}
export default { render: render }